import * as z from 'zod';

export const addNewProductSchema = z.object({
  sku: z
    .string()
    .trim()
    .min(1, { message: 'Product SKU should not be empty.' }),
  name: z
    .string()
    .trim()
    .min(1, { message: 'Product name should not be empty.' }),
  description: z.string().trim().optional(),
  taxCode: z
    .string()
    .trim()
    .min(1, { message: 'Product tax code should not be empty.' }),
});

export type AddProductFormFields = z.infer<typeof addNewProductSchema>;
